import { ButtonProps } from 'antd/lib/button';
import { useEffect, useState } from 'react';
import { MdNotifications } from 'react-icons/md';

import { NotificationsDrawer, useNotification } from '@framework/common-web';
import { t } from '@framework/i18n';
import { IconMenuBadge } from '@framework/ui';
import { TopMenuIconButton } from '../../../ui/menu/TopMenuIconButton';

export interface NotificationsButtonProps extends Omit<ButtonProps, 'type'> {}

export function NotificationsButton(props: NotificationsButtonProps) {
  const [visible, setVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  // true: lette; false: da leggere; undefined: tutte
  const [filterToRead, setFilterToRead] = useState<boolean | undefined>(
    undefined,
  );
  const PAGE_SIZE = 10;

  const query = {
    firstResult: (page - 1) * PAGE_SIZE,
    maxResults: PAGE_SIZE,
    sortField: 'DATA_NOTIFICA' as const,
    sortDirection: 'DESC' as const,
    flVista: filterToRead,
  };

  const { apiResult, notifications, notificationUpdate, meta, refetch } =
    useNotification(query);

  // Evito di azzerarlo quando cambio pagina
  useEffect(() => {
    if (meta.total == null) return;
    setTotal(meta.total);
  }, [meta.total]);

  const handleOpen = () => {
    refetch();
    setVisible(true);
  };

  const handleClose = () => {
    notificationUpdate.resetUnreadFlag();
    setVisible(false);
    setPage(1);
  };

  return (
    <>
      <TopMenuIconButton
        aria-controls="notifications-drawer"
        aria-expanded={visible}
        aria-label={t(
          'layout.header.pulsante-notifiche',
          '{{count}} notifiche da leggere',
          { count: notificationUpdate.unreadTotal },
        )}
        aria-live="polite"
        aria-atomic="true"
        icon={
          <IconMenuBadge count={notificationUpdate.unreadTotal}>
            <MdNotifications aria-hidden="true" size={22} />
          </IconMenuBadge>
        }
        onClick={handleOpen}
      />
      <NotificationsDrawer
        id="notifications-drawer"
        handleClose={handleClose}
        visible={visible}
        filterToRead={filterToRead}
        setFilterToRead={setFilterToRead}
        setPage={setPage}
        total={total}
        page={page}
        pageSize={PAGE_SIZE}
        notifications={notifications}
        apiResult={apiResult}
      />
    </>
  );
}
